// projects/humanresources-payroll/src/assets/i18n/*/hr-pay-payroll-switch-state.json
export class HrPayPayrollSwitchStateKey {
    private static readonly keyPrefix = 'hrPayPayrollSwitchState';
    public static pageHeader = `${HrPayPayrollSwitchStateKey.keyPrefix}.pageHeader`;
    public static code = `${HrPayPayrollSwitchStateKey.keyPrefix}.code`;
    public static state = `${HrPayPayrollSwitchStateKey.keyPrefix}.state`;
    public static enumState = `${HrPayPayrollSwitchStateKey.keyPrefix}.enumState`;
    public static employeeType = `${HrPayPayrollSwitchStateKey.keyPrefix}.employeeType`;
    public static periodSwitch = `${HrPayPayrollSwitchStateKey.keyPrefix}.periodSwitch`;
    public static payPayrollSwitch = `${HrPayPayrollSwitchStateKey.keyPrefix}.payPayrollSwitch`;
    public static periodDateBeginPeriod = `${HrPayPayrollSwitchStateKey.keyPrefix}.periodDateBeginPeriod`;
    public static periodDateBeginYear = `${HrPayPayrollSwitchStateKey.keyPrefix}.periodDateBeginYear`;
    public static periodDateCurrentPeriod = `${HrPayPayrollSwitchStateKey.keyPrefix}.periodDateCurrentPeriod`;
    public static periodDateCurrentYear = `${HrPayPayrollSwitchStateKey.keyPrefix}.periodDateCurrentYear`;
}
